import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../services/api";
import "./SubwayPaidouts.css";

const SubwayPaidouts = () => {
  const { id: businessId } = useParams();
  const navigate = useNavigate();

  const [storeNumber, setStoreNumber] = useState("");
  const [paidouts, setPaidouts] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [categories, setCategories] = useState([]);

  const [loading, setLoading] = useState(true);
  const [savingId, setSavingId] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [accounts, setAccounts] = useState([]);

  const [form, setForm] = useState({
    action: "",
    employee_id: "",
    plaid_category_id: "",
    account_id: "",
  });

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const formatCategoryName = (name) => {
  if (!name) return "";

  return name
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

  const fetchPageData = useCallback(async () => {
    if (!businessId || businessId === "undefined") {
      setMessage("Business ID is missing.");
      setMessageType("error");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);

      const storeRes = await api.get(`/subway-data/business-store/${businessId}`);
      const resolvedStore = String(storeRes.data?.store_number || "").trim();

      setStoreNumber(resolvedStore);

      if (!resolvedStore) {
        setPaidouts([]);
        setMessage("No Subway store number found for this business.");
        setMessageType("error");
        return;
      }

       const paidoutsRes = await api.get(`/subway-detail/paidouts/${resolvedStore}`);


const employeesRes = await api.get(`/subway-data/employees/${businessId}`);


const categoriesRes = await api.get(`/subway-data/categories/${businessId}`);


const accountsRes = await api.get(`/subway-data/accounts/${businessId}`);


setPaidouts(Array.isArray(paidoutsRes.data) ? paidoutsRes.data : []);
setEmployees(Array.isArray(employeesRes.data) ? employeesRes.data : []);
setCategories(Array.isArray(categoriesRes.data) ? categoriesRes.data : []);
setAccounts(Array.isArray(accountsRes.data) ? accountsRes.data : []);
    } catch (err) {
      console.error("Error loading Subway paidouts page:", err.response?.data || err.message);
      setMessage(err.response?.data?.message || "Failed to load Subway paidouts.");
      setMessageType("error");
    } finally {
      setLoading(false);
    }
  }, [businessId]);

  useEffect(() => {
    fetchPageData();
  }, [fetchPageData]);

  const startEdit = (row) => {
    setEditingId(row.id);
    setMessage("");
    setMessageType("");

    setForm({
      action: row.is_cashadvance ? "cash_advance" : row.add_to_transactions ? "transaction" : "",
      employee_id: row.employee_id ? String(row.employee_id) : "",
      plaid_category_id: row.plaid_category_id ? String(row.plaid_category_id) : "",
    });
  };

  const cancelEdit = () => {
    setEditingId(null);
    setForm({
      action: "",
      employee_id: "",
      plaid_category_id: "",
    });
  };

  const handleFormChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
      ...(field === "action"
        ? {
            employee_id: "",
            plaid_category_id: "",
          }
        : {}),
    }));
  };

  const handleSave = async (row) => {
    if (!form.action) {
      setMessage("Please select an action.");
      setMessageType("error");
      return;
    }

    if (form.action === "cash_advance" && !form.employee_id) {
      setMessage("Please select an employee.");
      setMessageType("error");
      return;
    }


    if (form.action === "transaction" && !form.account_id) {
  setMessage("Please select an account.");
  setMessageType("error");
  return;
}

    if (form.action === "transaction" && !form.plaid_category_id) {
      setMessage("Please select a category.");
      setMessageType("error");
      return;
    }



    const selectedCategory = categories.find(
      (cat) => String(cat.id) === String(form.plaid_category_id)
    );

    try {
      setSavingId(row.id);
      setMessage("");
      setMessageType("");

      await api.post(`/subway-detail/paidouts/${row.id}/process`, {
  action: form.action,
  employee_id: form.employee_id || null,
  plaid_category_id: form.plaid_category_id || null,
  category_name: selectedCategory?.name || null,
  account_id: form.account_id || null,
  business_id: businessId,
});

      setMessage("Paidout updated successfully.");
      setMessageType("success");
      cancelEdit();
      await fetchPageData();
    } catch (err) {
      console.error("Error saving paidout:", err.response?.data || err.message);
      setMessage(err.response?.data?.message || "Failed to save paidout.");
      setMessageType("error");
    } finally {
      setSavingId(null);
    }
  };

  const formatDate = (value) => {
    if (!value) return "";
    return new Date(value).toLocaleDateString();
  };

  const formatAmount = (value) => {
    return Number(value || 0).toFixed(2);
  };

  const getStatusLabel = (row) => {
  if (String(row.paidout_status).trim() === "cash_advance" || Number(row.is_cashadvance) === 1) {
    return "Cash Advance";
  }

  if (
    String(row.paidout_status).trim() === "added_to_transactions" ||
    Number(row.add_to_transactions) === 1
  ) {
    return "Added to Transactions";
  }

  return "Unclassified";
};

  return (
    <div className="subway-paidouts-page">
      <div className="subway-paidouts-card">
        <div className="subway-paidouts-header">
          <div>
            <h1 className="pw-page-title">Subway Paidouts</h1>
            <p className="subway-paidouts-store">
              Store: <strong>{storeNumber || "N/A"}</strong>
            </p>
          </div>

          <div className="subway-paidouts-actions">
            <button
              type="button"
              className=" avg-cogs-btn"
              onClick={() => navigate(`/dashboard/business/${businessId}/integration`)}
            >
              Back
            </button>

            <button
              type="button"n
              className=" avg-cogs-btn"
              onClick={fetchPageData}
              disabled={loading}
            >
              Refresh
            </button>
          </div>
        </div>

        {message ? (
          <div
            className={`subway-paidouts-message ${
              messageType === "success"
                ? "subway-paidouts-message-success"
                : "subway-paidouts-message-error"
            }`}
          >
            {message}
          </div>
        ) : null}

        {loading ? (
          <div className="subway-paidouts-status">Loading...</div>
        ) : paidouts.length === 0 ? (
          <div className="subway-paidouts-status">No paidouts found.</div>
        ) : (
          <div className="subway-paidouts-split-table">
          <div className="subway-paidouts-table-head">
            <table className="subway-paidouts-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Clerk</th>
                  <th>Amount</th>
                  <th>Comment</th>
                  <th>Status</th>
                  <th>Linked To</th>
                  <th>Action</th>
                </tr>
              </thead>
              </table>
              </div>
            
            <div className="subway-paidouts-table-body">
              <table className="subway-paidouts-table">
              <tbody>
                {paidouts.map((row) => {
                  const isEditing = editingId === row.id;

                  return (
                    <tr key={row.id}>
                      <td>{formatDate(row.paidout_date)}</td>
                      <td>{row.clerk_name || ""}</td>                     
                      <td className="subway-paidouts-money">${formatAmount(row.amount)}</td>
                      <td>{row.comment_text || ""}</td>
                      <td>
                        <span className={`subway-paidouts-badge ${row.paidout_status || "unclassified"}`}>
                          {getStatusLabel(row)}
                        </span>
                      </td>
                      <td>
  {String(row.paidout_status).trim() === "cash_advance" || Number(row.is_cashadvance) === 1 ? (
    <span>
      Cash Advance:{" "}
      {row.first_name || row.last_name
        ? `${row.first_name || ""} ${row.last_name || ""}`.trim()
        : `Employee #${row.employee_id}`}
    </span>
  ) : String(row.paidout_status).trim() === "added_to_transactions" ||
    Number(row.add_to_transactions) === 1 ? (
    <span>
      Transaction:{" "}
      
      {formatCategoryName(row.plaid_category_name) || `Category #${row.plaid_category_id}`}
      {row.plaid_transaction_id ? ` - ${row.plaid_transaction_id}` : ""}
    </span>
  ) : (
    <span className="subway-paidouts-muted">—</span>
  )}
</td>

                      <td>
                        {isEditing ? (
                          <div className="subway-paidouts-edit-box">
                            <select
                              className="subway-paidouts-input"
                              value={form.action}
                              onChange={(e) => handleFormChange("action", e.target.value)}
                            >
                              <option value="">Select Action</option>
                              <option value="cash_advance">Add to Cash Advance</option>
                              <option value="transaction">Add to Transactions</option>
                            </select>

                            {form.action === "cash_advance" ? (
                              <select
                                className="subway-paidouts-input"
                                value={form.employee_id}
                                onChange={(e) => handleFormChange("employee_id", e.target.value)}
                              >
                                <option value="">Select Employee</option>
                                {employees.map((employee) => (
                                  <option key={employee.id} value={employee.id}>
                                    {employee.first_name} {employee.last_name}
                                  </option>
                                ))}
                              </select>
                            ) : null}

                           {form.action === "transaction" ? (
  <>
    <select
      className="subway-paidouts-input"
      value={form.account_id}
      onChange={(e) => handleFormChange("account_id", e.target.value)}
    >
      <option value="">Select Account</option>
      {accounts.map((account) => (
        <option key={account.id} value={account.account_id || account.id}>
          {account.subtype ? `${account.subtype} - ` : ""}
          {account.mask}
        </option>
      ))}
    </select>

    <select
      className="subway-paidouts-input"
      value={form.plaid_category_id}
      onChange={(e) => handleFormChange("plaid_category_id", e.target.value)}
    >
      <option value="">Select Category</option>
      {categories.map((category) => (
       <option key={category.id} value={category.id}>
  {formatCategoryName(category.name)} ({category.type})
</option>
      ))}
    </select>
  </>
) : null}

                            <div className="subway-paidouts-edit-actions">
                              <button
                                type="button"
                                className="subway-paidouts-save-btn"
                                onClick={() => handleSave(row)}
                                disabled={savingId === row.id}
                              >
                                {savingId === row.id ? "Saving..." : "Save"}
                              </button>

                              <button
                                type="button"
                                className="subway-paidouts-cancel-btn"
                                onClick={cancelEdit}
                                disabled={savingId === row.id}
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        ) : (
                          <button
                            type="button"
                            className="subway-paidouts-edit-btn"
                            onClick={() => startEdit(row)}
                          >
                            Edit
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SubwayPaidouts;

// import React, { useCallback, useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import api from "../services/api";
// import "./SubwayPaidouts.css";

// const SubwayPaidouts = () => {
//   const { id: businessId } = useParams();
//   const navigate = useNavigate();

//   const [storeNumber, setStoreNumber] = useState("");
//   const [paidoutRows, setPaidoutRows] = useState([]);

//   const [loadingStore, setLoadingStore] = useState(true);
//   const [loadingPaidouts, setLoadingPaidouts] = useState(true);

//   const [message, setMessage] = useState("");
//   const [messageType, setMessageType] = useState("");

//   const fetchBusinessStore = useCallback(async () => {
//     if (!businessId || businessId === "undefined") {
//       setLoadingStore(false);
//       setMessage("Business ID is missing.");
//       setMessageType("error");
//       return "";
//     }

//     try {
//       setLoadingStore(true);

//       const response = await api.get(`/subway-data/business-store/${businessId}`);
//       const resolvedStoreNumber = String(response.data?.store_number || "").trim();

//       setStoreNumber(resolvedStoreNumber);
//       return resolvedStoreNumber;
//     } catch (err) {
//       console.error("Error loading business store number:", err.response?.data || err.message);
//       setMessage("Failed to load business store number.");
//       setMessageType("error");
//       setStoreNumber("");
//       return "";
//     } finally {
//       setLoadingStore(false);
//     }
//   }, [businessId]);

//   const fetchPaidouts = useCallback(async (resolvedStoreNumber) => {
//     if (!resolvedStoreNumber) {
//       setLoadingPaidouts(false);
//       setPaidoutRows([]);
//       return;
//     }

//     try {
//       setLoadingPaidouts(true);

//       const response = await api.get(`/subway-data/paidouts/${resolvedStoreNumber}`);
//       setPaidoutRows(Array.isArray(response.data) ? response.data : []);
//     } catch (err) {
//       console.error("Error loading subway paidouts:", err.response?.data || err.message);
//       setMessage("Failed to load subway paidouts.");
//       setMessageType("error");
//       setPaidoutRows([]);
//     } finally {
//       setLoadingPaidouts(false);
//     }
//   }, []);

//   useEffect(() => {
//     const loadPaidoutsPage = async () => {
//       const resolvedStoreNumber = await fetchBusinessStore();
//       await fetchPaidouts(resolvedStoreNumber);
//     };

//     loadPaidoutsPage();
//   }, [fetchBusinessStore, fetchPaidouts]);

//   const formatDate = (value) => {
//     if (!value) return "";
//     return new Date(value).toLocaleDateString();
//   };

//   const formatAmount = (value) => {
//     return Number(value || 0).toFixed(2);
//   };

//   const isLoading = loadingStore || loadingPaidouts;

//   return (
//     <div className="subway-paidouts-page">
//       <div className="subway-paidouts-card">
//         <div className="subway-paidouts-header">
//           <div>
//             <h1 className="subway-paidouts-title">Subway Paidouts</h1>
//             <p className="subway-paidouts-subtitle">
//               Store Number: <strong>{storeNumber || "N/A"}</strong>
//             </p>
//           </div>

//           <div className="subway-paidouts-actions">
//             <button
//               type="button"
//               className="avg-cogs-btn"
//               onClick={() => navigate(`/dashboard/business/${businessId}/integration`)}
//             >
//               Back to Integrations
//             </button>

//             <button
//               type="button"
//               className="avg-cogs-btn"
//               onClick={() => fetchPaidouts(storeNumber)}
//               disabled={!storeNumber || isLoading}
//             >
//               Refresh
//             </button>
//           </div>
//         </div>

//         {message ? (
//           <div
//             className={`subway-paidouts-message ${
//               messageType === "success"
//                 ? "subway-paidouts-message-success"
//                 : "subway-paidouts-message-error"
//             }`}
//           >
//             {message}
//           </div>
//         ) : null}

//         {isLoading ? (
//           <div className="subway-paidouts-status">Loading...</div>
//         ) : paidoutRows.length === 0 ? (
//           <div className="subway-paidouts-status">No paidouts found.</div>
//         ) : (
//           <div className="subway-paidouts-table-wrap">
//             <table className="subway-paidouts-table">
//               <thead>
//                 <tr>
//                   <th>Date</th>
//                   <th>Time</th>
//                   <th>Clerk ID</th>
//                   <th>Clerk Name</th>
//                   <th>No Sale Type</th>
//                   <th>Reason</th>
//                   <th>Reason Type</th>
//                   <th>Amount</th>
//                   <th>Comment</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {paidoutRows.map((row, index) => (
//                   <tr
//                     key={`${row.paidout_date || "date"}-${row.paidout_time || "time"}-${row.clerk_id || "clerk"}-${index}`}
//                   >
//                     <td>{formatDate(row.paidout_date)}</td>
//                     <td>{row.paidout_time || ""}</td>
//                     <td>{row.clerk_id || ""}</td>
//                     <td>{row.clerk_name || ""}</td>
//                     <td>{row.no_sale_type || ""}</td>
//                     <td>{row.reason || ""}</td>
//                     <td>{row.reason_type || ""}</td>
//                     <td>{formatAmount(row.amount)}</td>
//                     <td>{row.comment_text || ""}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SubwayPaidouts;